import React, { Component } from "react";
import injectSheet from 'react-jss/lib/injectSheet';
import { SearchIcons } from "./SearchIcons";

class AssetSearchStartAdornment extends Component {
    render () {
        const { classes, selectedTags } = this.props;

        return (
            <div className={classes.startAdornment}>
                <SearchIcons
                    iconName="search"
                    styles={{
                        color: 'rgb(146, 146, 146)',
                        paddingRight: '10px',
                    }}
                />
                <div className={classes.selectedTags}>
                    {selectedTags.map(tag => (
                        <span className={classes.selectedTag} key={tag}>tag: {tag}</span>
                    ))}
                </div>
            </div>
        );
    }
};

const style = ({ palette }) => ({
    startAdornment: {
        display: 'flex',
        flexFlow: 'row',
        marginRight: '8px',
        alignItems: 'center'
    },
    selectedTags: {
        display: 'flex',
        alignItems: 'center',
        maxWidth: '300px',
        overflowX: 'auto',
        scrollbarHeight: 0,
    },
    selectedTag: {
        marginRight: '4px',
        backgroundColor: '#e1f3ec'
    }
});


export default injectSheet(style)(AssetSearchStartAdornment);



// WEBPACK FOOTER //
// ./src/components/search/AssetSearchStartAdornment.js